import { ISelectOption } from "./selectOption.interface";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { ResourceCategory } from "../api/inventoryResource.model";
import { getResourceCategoryIconPath, getResourceCategoryDisplayName } from "src/app/common/categoryUtils";
import { BeautifyDisplayStringPipe } from "src/app/pipes/beautify-display-string/beautify-display-string.pipe";

export function getResourceCategorySelectOptions(beautifyDisplayStringPipe: BeautifyDisplayStringPipe): ISelectOption[] {
    return [
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.generic}`,
            value: ResourceCategory.generic,
            displayName: getResourceCategoryDisplayName(ResourceCategory.generic, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.generic),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.environment}`,
            value: ResourceCategory.environment,
            displayName: getResourceCategoryDisplayName(ResourceCategory.environment, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.environment),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.identity}`,
            value: ResourceCategory.identity,
            displayName: getResourceCategoryDisplayName(ResourceCategory.identity, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.identity),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.automation}`,
            value: ResourceCategory.automation,
            displayName: getResourceCategoryDisplayName(ResourceCategory.automation, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.automation),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.application}`,
            value: ResourceCategory.application,
            displayName: getResourceCategoryDisplayName(ResourceCategory.application, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.application),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.connection}`,
            value: ResourceCategory.connection,
            displayName: getResourceCategoryDisplayName(ResourceCategory.connection, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.connection),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.connector}`,
            value: ResourceCategory.connector,
            displayName: getResourceCategoryDisplayName(ResourceCategory.connector, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.connector),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.dataStorage}`,
            value: ResourceCategory.dataStorage,
            displayName: getResourceCategoryDisplayName(ResourceCategory.dataStorage, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.dataStorage),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.bot}`,
            value: ResourceCategory.bot,
            displayName: getResourceCategoryDisplayName(ResourceCategory.bot, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.bot),
        },
        {
            id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.aiExtension}`,
            value: ResourceCategory.aiExtension,
            displayName: getResourceCategoryDisplayName(ResourceCategory.aiExtension, beautifyDisplayStringPipe),
            categoryName: "Category",
            filterType: FilterTypesEnum.ResourceCategory,
            iconPath: getResourceCategoryIconPath(ResourceCategory.aiExtension),
        },
    ];
}
